import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/");
        return;
      }
      try {
        const ref = localStorage.getItem("bidmatch_ref") || "";
        const res = await api.post("/auth/session", { session_id: sessionId, ref });
        localStorage.removeItem("bidmatch_ref");
        setUser(res.data.user);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { state: { user: res.data.user } });
      } catch (e) {
        navigate("/");
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0F172A]" data-testid="auth-callback-loading">
      <div className="flex flex-col items-center gap-4">
        <div className="h-10 w-10 border-3 border-white/20 border-t-white rounded-full animate-spin" />
        <p className="text-white/70 font-data text-sm">Signing you in…</p>
      </div>
    </div>
  );
}
